import { FC } from 'react'
import Flex from '@/components/atoms/Grid/Flex'
import { Body2 } from '@/components/atoms/typography'
import styled from 'styled-components'
import { transparentize } from 'polished'
import { Box } from '@/components/atoms/Grid'
import { CheckIconDefault } from '../atoms/icons/CheckIconDefault'

type StatusBannerProps = {
  status: string
  statusColor: string
  icon: JSX.Element
} & Rest

const DetailStatusBanner: FC<StatusBannerProps> = ({
  status,
  statusColor,
  icon,
  ...rest
}) => (
  <StyledFlex
    backgroundColor={transparentize(0.85, statusColor)}
    px={15}
    {...rest}
  >
    {icon}
    <StyledText>{status}</StyledText>
  </StyledFlex>
)

export const DetailStatusSuccessIcon: FC<{ statusColor: string }> = ({
  statusColor
}) => <CheckIconDefault color={statusColor} ml={20} mr={15} />

export const DetailStatusWaitingIcon: FC<{ statusColor: string }> = ({
  statusColor
}) => (
  <Box
    my="auto"
    ml={20}
    mr={15}
    className="fcicon-order-waiting"
    color={statusColor}
  />
)

export default DetailStatusBanner

const StyledText = styled(Body2)`
  text-align: center;
`

const StyledFlex = styled(Flex)`
  border-radius: ${(props) => props.theme.borderRadius}px;
`
